module["exports"] = ["se", "nu", "info", "com", "org"];